import Precision from './Precision';
import resolvePrecisionActions from './resolvePrecisionActions';
import StoreName from '../Shared/Constants/StoreName';

const createPrecisionStore = state =>
    state.createStore({
        name: StoreName.PRECISION,
        model: Precision,
        actions: resolvePrecisionActions,
    });

export default createPrecisionStore;
